import React, { useEffect } from "react";
import { qris } from "../assets";
import { useNavigate } from "react-router-dom";
import { QRCode } from "react-qrcode-logo";
import { changeDateFormat, getSpecificPayment } from "../constants";

const PaymentOrder = ({
  data,
  handleCheckStatus,
  token,
  paymentId,
  setData,
  setLoading,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    // Set up interval to fetch data every 5 seconds (5000 milliseconds)
    const intervalId = setInterval(() => {
      getSpecificPayment(token, paymentId, setData, (e) => undefined);
    }, 5000);
    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="flex flex-col w-full h-full justify-between items-start bg-white text-black p-8 gap-10">
      <div className="flex flex-col w-full gap-5 h-full">
        <div className="text-[32px] font-bold">Payment</div>
        <div className="flex flex-col gap-5 w-full justify-center items-center h-full border rounded-lg py-10 md:py-0">
          <img src={qris} alt="" />
          <div className="flex flex-col text-center px-10">
            Please pay before {changeDateFormat(data.expires_at)}
          </div>
          <img
            src={data.qrcode_url}
            alt="QRIS"
            className="w-[200px] h-[200px]"
          />
          {/* <QRCode
            value={data.qr_string || ""}
            size={200}
            qrStyle={"dots"}
            logoOpacity={0.15}
            // e
            // yeColor={"#F2994A"}
          /> */}
          <div className="hidden">
            {" "}
            {/* <QRCode
              id={"qr_id"}
              value={data.qr_string || ""}
              size={500}
              qrStyle={"dots"}
              logoOpacity={0.15}
              bgColor={"transparent"}
              level={"H"}
              className="hidden"
            /> */}
            <img
              id="qr_id"
              src={data.qrcode_url}
              alt="QRIS"
              className="hidden w-[500px] h-[500px]"
            />
          </div>
          <a
            className="text-blue-700 link-hover cursor-pointer"
            href={data.qrcode_url}
            download
          >
            Download QR Code
          </a>
        </div>
      </div>

      <div className="flex flex-row justify-between items-center w-full gap-20">
        <div
          className="flex text-center w-[200px] py-2 border border-primary text-primary items-center justify-center rounded-md shadow-lg cursor-pointer"
          onClick={() => navigate("/")}
        >
          Home
        </div>
        <div
          className={`flex text-center w-[200px] py-2 border bg-primary cursor-pointer text-white items-center justify-center rounded-md shadow-lg `}
          onClick={handleCheckStatus}
        >
          Check Status
        </div>
      </div>
    </div>
  );
};

export default PaymentOrder;
